import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Olá visitante, meu nome é <span className="purple">Luiz Augusto </span>
            moro em <span className="purple"> Valinhos-SP.</span>
            <br />Sou formado em <span className="purple"> Desenvolvimento Full-Stack </span> pela Kenzie Academy Brasil e atualmente estou  estudando para me tornar um<span className="purple"> Engenheiro de Software </span>pela universidade
            de Santo Amaro.
            <br />
            <br />
            Além de codar, algumas outras atividades que adoro fazer!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Jogar Vídeo-Game
            </li>
            <li className="about-activity">
              <ImPointRight /> Assistir Séries
            </li>
            <li className="about-activity">
              <ImPointRight /> Ler
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            “Você pode criar qualquer coisa: basta escrever”{" "}
          </p>
          <footer className="blockquote-footer">C.S. Lewis</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
